// importando estilização do componente
import style from './ButtonIndicator.module.css'
// import {StyledButtonIndicator} from './StyledButtonIndicator'
import Circle from '../../../../img/SVG/circle/Circle'
import React from 'react'

interface IButtonIndicator {
    key: React.Key | null | undefined
    id:number
    click: (num: number) => void
}

export const ButtonIndicator: React.FC <IButtonIndicator> = (props) =>{     
    function click (){
        props.click(props.id)
    }
    return (       
        <button className={style.IndicatorContent} onClick={click}>
            <Circle /> 
        </button>            
    )
}
// aqui estamos exportando nosso componente
